module.exports = __webpack_public_path__ + "img/logo_gki_white.9441cbde.png";